// ./jobtypes/singleSvCnv.js

export const organizeSingleSvCnv = (files /*, data */) => {
  // Find the AnnotSV TSV produced by SingleCNVSV.sh
  const ann =
    files.find(f => /_(DEL|DUP|INS|INV|CNV)\.annotated\.tsv$/i.test(f.name || '')) ||
    files.find(f => /\.annotated\.tsv$/i.test(f.name || ''));

  const tsv = ann?.data || '';
  const tab = 'CNV/SV';
  const tableName = ann?.name || 'Annotated';

  const organized = {
    [tab]: {
      tables: [
        { name: tableName, data: tsv } // DataTable will render the raw TSV
      ]
    }
  };

  return {
    organized,
    renderers: {},                    // no custom renderer; default DataTable path
    initial: { tab, sub: tableName }  // open directly on this table
  };
};
